<template>
  <div class="d-flex">
    <v-img
      lazy-src="@/assets/animal_chara_fukurou_hakase.png"
      src="@/assets/animal_chara_fukurou_hakase.png"
      height="150"
      aspect-ratio="1.7"
      max-width="100"
    />
    <div
      class="form-comment"
      :class="{ 'is--active': isActive, 'is-edit': mainGrammar != 'Edit' }"
      style="max-width: 230px; min-width: 230px"
    >
      <h4 v-bind="attributesBinding">
        {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
        <span />
      </h4>
      <p
        class="ma-0 text-caption"
        v-if="mainGrammar == 'Preview' && isLanguage !== 'ja'"
      >
        {{ captionText }}
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: "Label",
  store: ["main", "mainGrammar", "isLanguage"],
  props: ["currentField", "isActive"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  word-wrap: break-word !important;
  white-space: pre-line;
  line-height: 1 !important;
}
.form-comment {
  user-select: none;
  border: 2px solid orange;
  border-radius: 4px;
  word-wrap: break-word;
  white-space: pre-line;
  min-height: 3rem;
  margin: 25px 10px 4px 4px;
  position: relative;
  padding: 4px;
}
.form-comment::after {
  content: "";
  position: absolute;
  width: 20px;
  border-top: 10.5px solid transparent;
  border-right: 9.5px solid #f5f3e5;
  border-bottom: 11.5px solid transparent;
  left: -1.2rem;
  top: 1.37rem;
}
.is--active::after {
  content: "";
  position: absolute;
  width: 20px;
  border-top: 10.5px solid transparent;
  border-right: 9.5px solid #ecf5ff;
  border-bottom: 11.5px solid transparent;
  left: -1.2rem;
  top: 1.37rem;
}
.is-edit::after {
  border-right: 9.5px solid #ffffff !important;
}
.form-comment h4 span::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-top: 11.6px solid transparent;
  border-right: 10px solid orange;
  border-bottom: 12px solid transparent;
  left: -1.3rem;
  top: 1.34rem;
}
</style>
